import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { downloadReportPDF } from '../../../api/assessment';
import Card from '../../Card';
import Button from '../../Button';
import DegradedBanner from '../DegradedBanner';
import CourseCTACard from '../CourseCTACard';

/**
 * V4 P5：综合评价（≥400 字）+ 提升方案（≥300 字）+ 操作区。
 *
 * narrative_v4.final_eval = { text, model_used, degraded, attempts }
 *
 * V4 M21 F.5（设计文档 3.6 节）：course_recommendation 字段由 backend
 * 在 enable_student_course_recommendation flag 开启时写入；前端按 truthy
 * 渲染独立 CourseCTACard 组件，flag 关闭则字段不存在不渲染 CTA。
 */
export default function V4P5FinalEval({ report }) {
  const { assessmentId } = useParams();
  const navigate = useNavigate();
  const [downloading, setDownloading] = useState(false);

  const finalEval = report?.narrative_v4?.final_eval || {};
  const finalText = finalEval.text || '';
  const courseRec = report?.narrative_v4?.course_recommendation;

  const handleDownloadPDF = async () => {
    setDownloading(true);
    try {
      const { data } = await downloadReportPDF(assessmentId);
      const blob = new Blob([data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `AIQ报告_${assessmentId}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      let detail = 'PDF 下载失败，请稍后再试';
      if (err.response?.data instanceof Blob) {
        try {
          const text = await err.response.data.text();
          const json = JSON.parse(text);
          if (json.detail) detail = json.detail;
        } catch { /* ignore */ }
      }
      alert(detail);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div data-testid="report-v4-p5">
      <Card
        data-testid="report-v4-p5-final-eval"
        style={{ padding: '24px 28px', marginBottom: 24, borderLeft: '4px solid var(--color-primary, #1a3a6b)' }}
      >
        <h2 style={{ fontSize: 16, fontWeight: 700, marginTop: 0, marginBottom: 12, color: 'var(--color-primary, #1a3a6b)' }}>
          综合评价 + 提升方案
        </h2>
        {finalEval.degraded && <DegradedBanner />}
        <p style={{
          fontSize: 14, lineHeight: 1.85, color: 'var(--color-text)',
          whiteSpace: 'pre-wrap', margin: 0,
        }}>
          {finalText || '（暂无内容）'}
        </p>
      </Card>

      <CourseCTACard rec={courseRec} />


      <Card style={{ padding: '20px 28px' }} data-testid="report-v4-p5-actions">
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <Button variant="secondary" onClick={() => navigate('/')}>返回首页</Button>
          <Button onClick={() => navigate('/assessment/rules')}>再次测评</Button>
          <Button variant="secondary" onClick={() => navigate('/history')}>查看历史</Button>
          <Button
            variant="secondary"
            loading={downloading}
            onClick={handleDownloadPDF}
            style={{ borderColor: '#16a34a', color: '#16a34a' }}
          >
            下载 PDF 报告
          </Button>
        </div>
      </Card>
    </div>
  );
}
